import React from "react";

function OtherInfo({ formData, setFormData }) {
  const opcionesSelect1 = [
    "Cordón HO5VV-F",
    "Alambre NYA h07V-U",
    "Cable H0771-K",
    "Cable THHN",
    "Cable Caleco",
    "Cable Superflex",
    "Cable Preensamblado",
    "Cable Concéntrico",
    "Cable Eva",
    "Aluminio Subterráneo",
  ];
  const opcionesSelect2 = {
    "Cordón HO5VV-F": ["PVC"],
    "Alambre NYA h07V-U": ["PVC"],
    "Cable H0771-K": ["PVC"],
    "Cable THHN": ["PVC"],
    "Cable Caleco": ["PVC"],
    "Cable Superflex": ["XLPE"],
    "Cable Preensamblado": ["XLPE"],
    "Cable Concéntrico": ["PVC"],
    "Cable Eva": ["Evaflex"],
    "Aluminio Subterráneo": ["XLPE"],
  };

  const handleSelectChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSelect1Change = (campo, event) => {
    const nuevaOpcion = event.target.value;
    setFormData({ ...formData, [campo]: nuevaOpcion });
  };

  return (
    <div className="other-info-container">
      <div>
        <label htmlFor="destinoPropietario" className="form-label">
          Destino Instalación
        </label>
        <select
          value={formData.destinoPropiedad}
          onChange={handleSelectChange}
          //className="form-select"
          id="destinoPropiedad"
          name="destinoPropiedad"
          required
        >
          <option value={null}>Seleccione</option>
          <option
            value={"Actividades Inmobiliarias Empresariales y de Alquiler"}
          >
            Actividades Inmobiliarias empresariales y de alquiler
          </option>
          <option
            value={
              "Adm. pública y defensa; Planes de Seg. Social, Afiliación Obligatoria"
            }
          >
            Adm. pública y defensa; Planes de Seg. Social, Afiliación
            obligatoria
          </option>
          <option value={"Agricultura, Ganadería, Caza y Silvicultura"}>
            Agricultura, Ganadería, Caza y Silvicultura
          </option>
          <option
            value={
              "Comercio al Por Mayor y Menor; Rep.Vehículos Automotores/Enseres Domésticos."
            }
          >
            Comercio al Por Mayor y Menor; Rep. Vehículos Automotores/Enseres
            Domésticos.
          </option>
          <option
            value={"Consejo de Administración de Edificios y Condominios"}
          >
            Consejo de Administración de Edificios y Condominios
          </option>
          <option value={"Construcción"}>Construcción</option>
          <option value={"Enseñanza"}>Enseñanza</option>
          <option value={"Explotación de Minas y Canteras"}>
            Explotación de Minas y Canteras
          </option>
          <option value={"Habitacional"}>Habitacional</option>
          <option value={"Hoteles y Restaurantes"}>
            Hoteles y Restaurantes
          </option>
          <option value={"Industrias Manufactureras Metálicas"}>
            Industrias Manufactureras Metálicas
          </option>
          <option value={"Industrias Manufactureras No Metálicas"}>
            Industrias Manufactureras No Metálicas
          </option>
          <option value={"Intermediación Financiera"}>
            Intermediación Financiera
          </option>
          <option value={"Organizaciones y Órganos Extraterritoriales"}>
            Organizaciones y Órganos Extraterritoriales
          </option>
          <option
            value={
              "Otras Actividades de Servicios Comunitarias, Sociales y Personales"
            }
          >
            Otras Actividades de Servicios Comunitarias, Sociales y Personales
          </option>
          <option value={"Pesca"}>Pesca</option>
          <option value={"Servicios Sociales y de Salud"}>
            Servicios Sociales y de Salud
          </option>
          <option value={"Suministro de Electricidad, Gas y Agua"}>
            Suministro de Electricidad, Gas y Agua
          </option>
          <option value={"Transporte, Almacenamiento y Comunicaciones"}>
            Transporte, Almacenamiento y Comunicaciones
          </option>
        </select>
      </div>

      <div>
        <label htmlFor="largoAlimentador" className="form-label">
          Largo Alimentador (en metros)
        </label>

        <input
          type="number"
          placeholder="Largo Alimentador"
          value={formData.largoAlimentador}
          min={1}
          onChange={(e) =>
            setFormData({ ...formData, largoAlimentador: e.target.value })
          }
          required
        />
      </div>

      <div className="calibre">
        <label htmlFor="calibreAlimentador" className="form-label">
          Calibre Alimentador
        </label>

        <div className="form-label">
          <input
            type="number"
            placeholder="calibreAlimentador"
            value={formData.calibreAlimentador}
            min={1}
            onChange={(e) =>
              setFormData({ ...formData, calibreAlimentador: e.target.value })
            }
            required
          />
        </div>

        <div className="form-label">
          <select
            value={formData.um}
            onChange={handleSelectChange}
            //className="form-select"
            id="um"
            name="um"
            required
          >
            <option value={null}>Seleccione</option>
            <option value={"mm"}>mm2</option>
            <option value={"awg"}>AWG</option>
          </select>
        </div>
      </div>

      <div>
        <label htmlFor="tipoCable" className="form-label">
          Tipo Alimentador
        </label>

        <select
          value={formData.tipoCable}
          onChange={(event) => handleSelect1Change("tipoCable", event)}
          id="tipoCable"
          name="tipoCable"
          required
        >
          <option value="">Selecciona una opción</option>
          {opcionesSelect1.map((opcion) => (
            <option key={opcion} value={opcion}>
              {opcion}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="aislacionCable" className="form-label">
          Aislación Alimentador
        </label>

        <select
            value={formData.aislacionCable}
          //onChange={(event) => handleSelect1Change("aislacionCable", event)}
          onChange={handleSelectChange}
          id="aislacionCable"
          name="aislacionCable"
          required
          >
            <option value={null}>Seleccione</option>
            <option value={"PVC"}>PVC</option>
            <option value={"XLPE"}>XLPE</option>
            <option value={"Evaflex"}>Evaflex</option>

          </select>

        {/*   <select
          value={formData.aislacionCable}
          onChange={(event) => handleSelect1Change("aislacionCable", event)}
          id="aislacionCable"
          name="aislacionCable"
          required
        >
          <option value="">Selecciona una opción</option>
          {opcionesSelect2.map((opcion) => (
            <option key={opcion} value={opcion}>
              {opcion}
            </option>
          ))}
          </select>  */}



        <div>
          <label htmlFor="canalizacion" className="form-label">
            Canalización Alimentador
          </label>
          <select
            value={formData.canalizacion}
          //onChange={(event) => handleSelect1Change("aislacionCable", event)}
          onChange={handleSelectChange}
          id="canalizacion"
          name="canalizacion"
          required
          >
            <option value={null}>Seleccione</option>
            <option value={"a"}>Aérea</option>
            <option value={"s"}>Subterránea</option>
           

          </select>
        </div>
      </div>
    </div>
  );
}

export default OtherInfo;

//con este linea se reemplazo opcionselect2

/*{opcionesSelect2[formData.tipoCable] &&
  opcionesSelect2[formData.tipoCable].map((opcion) => (
    <option key={opcion} value={opcion}>
      {opcion}
    </option>*/
